export default {
      id: "oc-res-suggestsyoverview-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-suggestsyoverview",
      toString: function () {
        return this.url;
      }
    }